export default __webpack_public_path__ + "static/media/1.1fd0c1e3.png";